import {ApolloClient, InMemoryCache, HttpLink, ApolloLink, from, NormalizedCacheObject} from '@apollo/client';
import {setContext} from '@apollo/client/link/context';
import {onError} from '@apollo/client/link/error';
import {RetryLink} from '@apollo/client/link/retry';
import ApolloLinkTimeout from 'apollo-link-timeout';

const timeoutLink = new ApolloLinkTimeout(30000);

const retryLink = new RetryLink();

const perfLink = new ApolloLink((operation, forward) => {
  const {operationName, variables, query} = operation;
  const requestPayload = {operationName, variables, query: query?.loc?.source?.body};
  return forward(operation).map((response) => {
    const responseData = response?.data;
    const sentryPayload = {
      ...(requestPayload || {}),
      response_data: {
        ...(responseData || {})
      }
    };
    sentryPayload;
    return response;
  });
});

const errorLink = onError(({graphQLErrors, response, operation}) => {
  const {operationName, variables, query} = operation;
  const requestPayload = {operationName, variables, query: query?.loc?.source?.body};
  const responseData = response?.data;

  if (graphQLErrors?.length) {
    graphQLErrors.forEach((error) => {
      const sentryPayload = {
        ...(requestPayload || {}),
        response_data: {
          ...(responseData || {})
        },
        error
      };
      sentryPayload;
    });
  }
});

const authLink = (idToken?: string) =>
  setContext(async (_, {headers}) => {
    const modifiedHeader: Record<string, any> = {
      headers: {
        ...headers
      }
    };
    if (idToken) {
      modifiedHeader.headers['authorization'] = `Bearer ${idToken}`;
      return modifiedHeader;
    }
  });

const cache = new InMemoryCache();

const getClient = (uri: string, idToken?: string): ApolloClient<NormalizedCacheObject> => {
  const appHeaders: Record<string, any> = {};

  appHeaders['x-app-version-code'] = '1.0.0';
  appHeaders['x-app-version'] = '2.2.0';
  appHeaders['x-device-platform'] = 'ios';

  const appVersionLink = setContext((_, {headers}) => ({
    headers: {
      ...headers,
      ...appHeaders
    }
  }));

  const httpLink = new HttpLink({
    uri: uri
  });

  const timeoutHttpLink = timeoutLink.concat(httpLink);
  return new ApolloClient({
    uri: uri,
    cache,
    defaultOptions: {
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all'
      }
    },
    link: from([authLink(idToken), appVersionLink, perfLink, errorLink, retryLink, timeoutHttpLink])
  });
};

export default getClient;
